import { AppContent } from "./app/AppContent";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import init from "./app/init";
import CONFIG from "./model/TSConfig";
import { SIGNUP } from "./utils/routes/routes";

export default function () {
  const dispatch = useDispatch();
  const history = useHistory();

  const [masterInitDone, setMasterInitDone] = useState(false);

  useEffect(() => {
    init(dispatch, history)
      .then(() => {
        setMasterInitDone(true);
      })
      .catch((err) => {
        window.location.pathname = `${CONFIG.baseName}${SIGNUP}`;
        setMasterInitDone(true);
      });
  }, []);

  if (!masterInitDone) {
    return null;
  }

  return <AppContent />;
}
